<template>
  <router-view />
</template>
<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
@import "styles/app.scss";
html {
  overflow: auto !important;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $white;
}
</style>
